import { Component, OnInit, Input } from '@angular/core';
import { EncuestaCovidPreguntaDetalleEntity } from '../../../../services/servicio-encuesta-covid.service';

@Component({
  selector: 'app-area-texto',
  templateUrl: './area-texto.component.html',
  styleUrls: ['./area-texto.component.css']
})
export class AreaTextoComponent implements OnInit {

  value: string;
  
  @Input() public pregunta: EncuestaCovidPreguntaDetalleEntity;

  constructor() { }

  ngOnInit() {
    if (this.pregunta && this.pregunta.resultado) {
      this.value = this.pregunta.resultado.resultado;
    } else {
      this.value = '';
    }
  }

}
